import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="MainContent"
        className="content-for-layout focus-none page- page-"
        role="main"
        tabIndex={-1}
      >
        <div className="shopify-policy__container">
          <div className="shopify-policy__title">
            <h1>Terms of service</h1>
          </div>
          <div className="shopify-policy__body">
            <div className="rte">
              <p>
                <strong>OVERVIEW</strong> <br /> This website is operated by
                Sadiemall. Throughout the site, the terms “we”, “us” and “our”
                refer to Sadiemall. Sadiemall offers this website, including all
                information, tools and services available from this site to you,
                the user, conditioned upon your acceptance of all terms,
                conditions, policies and notices stated here. <br /> <br /> By
                visiting our site and/ or purchasing something from us, you
                engage in our “Service” and agree to be bound by the following
                terms and conditions (“Terms of Service”, “Terms”), including
                those additional terms and conditions and policies referenced
                herein and/or available by hyperlink. These Terms of Service
                apply to all users of the site, including without limitation
                users who are browsers, vendors, customers, merchants, and/ or
                contributors of content. <br /> <br /> Please read these Terms
                of Service carefully before accessing or using our website. By
                accessing or using any part of the site, you agree to be bound
                by these Terms of Service. If you do not agree to all the terms
                and conditions of this agreement, then you may not access the
                website or use any services. If these Terms of Service are
                considered an offer, acceptance is expressly limited to these
                Terms of Service. <br /> <br /> Any new features or tools which
                are added to the current store shall also be subject to the
                Terms of Service. You can review the most current version of the
                Terms of Service at any time on this page. We reserve the right
                to update, change or replace any part of these Terms of Service
                by posting updates and/or changes to our website. It is your
                responsibility to check this page periodically for changes. Your
                continued use of or access to the website following the posting
                of any changes constitutes acceptance of those changes. <br />{" "}
                <br /> Our store is hosted on Shopify Inc. They provide us with
                the online e-commerce platform that allows us to sell our
                products and services to you. <br /> <br />{" "}
                <strong>SECTION 1 - ONLINE STORE TERMS</strong> <br /> By
                agreeing to these Terms of Service, you represent that you are
                at least the age of majority in your state or province of
                residence, or that you are the age of majority in your state or
                province of residence and you have given us your consent to
                allow any of your minor dependents to use this site. <br /> You
                may not use our products for any illegal or unauthorized purpose
                nor may you, in the use of the Service, violate any laws in your
                jurisdiction (including but not limited to copyright laws).{" "}
                <br /> You must not transmit any worms or viruses or any code of
                a destructive nature. <br /> A breach or violation of any of the
                Terms will result in an immediate termination of your Services.{" "}
                <br /> <br /> <strong>SECTION 2 - GENERAL CONDITIONS</strong>{" "}
                <br /> We reserve the right to refuse service to anyone for any
                reason at any time. <br /> You understand that your content (not
                including credit card information), may be transferred
                unencrypted and involve (a) transmissions over various networks;
                and (b) changes to conform and adapt to technical requirements
                of connecting networks or devices. Credit card information is
                always encrypted during transfer over networks. <br /> You agree
                not to reproduce, duplicate, copy, sell, resell or exploit any
                portion of the Service, use of the Service, or access to the
                Service or any contact on the website through which the service
                is provided, without express written permission by us. <br />{" "}
                The headings used in this agreement are included for convenience
                only and will not limit or otherwise affect these Terms. <br />{" "}
                <br />{" "}
                <strong>
                  SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF
                  INFORMATION
                </strong>{" "}
                <br /> We are not responsible if information made available on
                this site is not accurate, complete or current. The material on
                this site is provided for general information only and should
                not be relied upon or used as the sole basis for making
                decisions without consulting primary, more accurate, more
                complete or more timely sources of information. Any reliance on
                the material on this site is at your own risk. <br /> This site
                may contain certain historical information. Historical
                information, necessarily, is not current and is provided for
                your reference only. We reserve the right to modify the contents
                of this site at any time, but we have no obligation to update
                any information on our site. You agree that it is your
                responsibility to monitor changes to our site. <br /> <br />{" "}
                <strong>
                  SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES
                </strong>{" "}
                <br /> Prices for our products are subject to change without
                notice. <br /> We reserve the right at any time to modify or
                discontinue the Service (or any part or content thereof) without
                notice at any time. <br /> We shall not be liable to you or to
                any third-party for any modification, price change, suspension
                or discontinuance of the Service. <br /> <br />{" "}
                <strong>
                  SECTION 5 - PRODUCTS OR SERVICES (if applicable)
                </strong>{" "}
                <br /> Certain products or services may be available exclusively
                online through the website. These products or services may have
                limited quantities and are subject to return or exchange only
                according to our Return Policy. <br /> We have made every effort
                to display as accurately as possible the colors and images of
                our products that appear at the store. We cannot guarantee that
                your computer monitor's display of any color will be accurate.{" "}
                <br /> We reserve the right, but are not obligated, to limit the
                sales of our products or Services to any person, geographic
                region or jurisdiction. We may exercise this right on a
                case-by-case basis. We reserve the right to limit the quantities
                of any products or services that we offer. All descriptions of
                products or product pricing are subject to change at anytime
                without notice, at the sole discretion of us. We reserve the
                right to discontinue any product at any time. Any offer for any
                product or service made on this site is void where prohibited.{" "}
                <br /> We do not warrant that the quality of any products,
                services, information, or other material purchased or obtained
                by you will meet your expectations, or that any errors in the
                Service will be corrected. <br /> <br />{" "}
                <strong>
                  SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION
                </strong>{" "}
                <br /> We reserve the right to refuse any order you place with
                us. We may, in our sole discretion, limit or cancel quantities
                purchased per person, per household or per order. These
                restrictions may include orders placed by or under the same
                customer account, the same credit card, and/or orders that use
                the same billing and/or shipping address. In the event that we
                make a change to or cancel an order, we may attempt to notify
                you by contacting the e‑mail and/or billing address/phone number
                provided at the time the order was made. We reserve the right to
                limit or prohibit orders that, in our sole judgment, appear to
                be placed by dealers, resellers or distributors. <br /> <br />{" "}
                You agree to provide current, complete and accurate purchase and
                account information for all purchases made at our store. You
                agree to promptly update your account and other information,
                including your email address and credit card numbers and
                expiration dates, so that we can complete your transactions and
                contact you as needed. <br /> <br /> For more detail, please
                review our Returns Policy. <br /> <br />{" "}
                <strong>SECTION 7 - OPTIONAL TOOLS</strong> <br /> We may
                provide you with access to third-party tools over which we
                neither monitor nor have any control nor input. <br /> You
                acknowledge and agree that we provide access to such tools ”as
                is” and “as available” without any warranties, representations
                or conditions of any kind and without any endorsement. We shall
                have no liability whatsoever arising from or relating to your
                use of optional third-party tools. <br /> Any use by you of
                optional tools offered through the site is entirely at your own
                risk and discretion and you should ensure that you are familiar
                with and approve of the terms on which tools are provided by the
                relevant third-party provider(s). <br /> We may also, in the
                future, offer new services and/or features through the website
                (including, the release of new tools and resources). Such new
                features and/or services shall also be subject to these Terms of
                Service. <br /> <br />{" "}
                <strong>
                  SECTION 8 -&nbsp;MOBILE PROGRAM TERMS OF SERVICE
                </strong>
              </p>
              <p>
                Sadiemall
                <br />
                Mobile Message Service Terms and Conditions
                <br />
                <br />
                Last updated:&nbsp;2021/08/31
                <br />
                <br />
                The Sadiemall mobile message service (the "Service") is operated
                by Sadiemall, “we”, or “us”). Your use of the Service
                constitutes your agreement to these terms and conditions
                (“Mobile Terms”). We may modify or cancel the Service or any of
                its features without notice. To the extent permitted by
                applicable law, we may also modify these Mobile Terms at any
                time and your continued use of the Service following the
                effective date of any such changes shall constitute your
                acceptance of such changes.
                <br />
                <br />
                We do not charge for the Service, but you are responsible for
                all charges and fees associated with text messaging imposed by
                your wireless provider. Message and data rates may apply.
                <br />
                <br />
                Text messages may be sent using an automatic telephone dialing
                system or other technology. Your consent to receive autodialed
                marketing text messages is not required as a condition of
                purchasing any goods or services. If you have opted in, the
                Service provides updates, alerts, and information (e.g., order
                updates, account alerts, etc.), promotions, specials, and other
                marketing offers (e.g., cart reminders)] from&nbsp;Sadiemall via
                text messages through your wireless provider to the mobile
                number you provided. Message frequency varies. Text the single
                keyword command STOP to
                <span>+1 (833) 930-3765</span> Click the unsubscribe link in any
                text message to cancel at any time. You'll receive a one-time
                opt-out confirmation text message. If you have subscribed to
                other&nbsp;Sadiemall mobile message programs and wish to cancel,
                except where applicable law requires otherwise, you will need to
                opt out separately from those programs by following the
                instructions provided in their respective mobile terms. For
                Service support or assistance, text HELP to{" "}
                <span>+1 (833) 930-3765</span> or
                email&nbsp;find@sadiemall.site.
                <br />
                <br />
                We may change any short code or telephone number we use to
                operate the Service at any time and will notify you of these
                changes. You acknowledge that any messages, including any STOP
                or HELP requests, you send to a short code or telephone number
                we have changed may not be received and we will not be
                responsible for honoring requests made in such messages.
                <br />
                <br />
                The wireless carriers supported by the Service are not liable
                for delayed or undelivered messages. You agree to provide us
                with a valid mobile number. You agree to maintain accurate,
                complete, and up-to-date information with us related to your
                receipt of messages. <br />
                <br />
                To the extent permitted by applicable law, you agree that we
                will not be liable for failed, delayed, or misdirected delivery
                of any information sent through the Service, any errors in such
                information, and/or any action you may or may not take in
                reliance on the information or Service.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>
                  SECTION 9 - THIRD-PARTY LINKSSMS MOBILE MESSAGE MANAGEMENT
                  PROGRAM TERMS AND CONDITIONS
                </strong>
              </p>
              <p>
                <em>Last revised: May 12, 2021</em>
              </p>
              <p>
                We and together with our partner ReCharge Inc. (hereinafter,
                “Recharge”) is offering a mobile messaging program (the
                “Program”), which you agree to use and participate in subject to
                these Mobile Messaging Terms and Conditions&nbsp; (“Program
                Terms”).&nbsp;
                <strong>
                  By opting in to or participating in the Program, you accept
                  and agree to these Program Terms, including, without
                  limitation, your agreement to resolve any disputes with us
                  and/or Recharge through binding, individual-only arbitration,
                  as detailed in the “Dispute Resolution” section below.
                </strong>
                &nbsp;These Program Terms are limited to the Program and are not
                intended to modify other agreements or terms and conditions that
                may govern the relationship between you and Us, or you and
                Recharge in other contexts.
              </p>
              <h4>User Agreement to Receive Text Messages</h4>
              <p>
                You agree to receive SMS mobile messages from Us and Recharge at
                the phone number you provided when you signed up for your
                subscription, and any additional or updated phone number you
                provide as a contact number in connection with your
                subscription. Regardless of how you joined the Program, you
                agree that these Program Terms apply to your participation in
                the Program. You agree to receive autodialed, prerecorded, or
                predetermined mobile messages at the phone number associated
                with your subscription, and you understand that your consent to
                receive these messages is not required to make any purchase.
                These messages will include information on how to manage your
                subscription and may include special offers and other
                promotional content. While you consent to receive messages sent
                using an autodialer, the foregoing shall not be interpreted to
                suggest or imply that any or all of the mobile messages you
                receive from Us or Recharge are sent using an automatic
                telephone dialing system (“ATDS” or “autodialer”). Message and
                data rates may apply.
              </p>
              <h4>User Opt Out</h4>
              <p>
                If you do not wish to continue participating in the Program or
                no longer agree to these Program Terms, you agree to reply STOP
                to any mobile message from Recharge in order to opt out of the
                Program. You also may email Recharge with your phone number and
                the subscription for which you wish to opt out of the Program at
                <span>&nbsp;</span>
                <Link onClick={toTop} to="mailto:find@sadiemall.site">
                  find@sadiemall.site
                </Link>
                . You may continue to receive SMS messages while we process your
                request, and you may receive a mobile message confirming your
                decision to opt out. You understand and agree that the foregoing
                options are the only reasonable methods of opting out of the
                Program. You also understand and agree that any other method of
                opting out, including, but not limited to, texting words other
                than those set forth above or verbally requesting one of our
                employees to remove you from our list, is not a reasonable means
                of opting out.
              </p>
              <h4>Duty to Notify and Indemnify</h4>
              <p>
                If at any time you intend to stop using the mobile telephone
                number that has been used to subscribe to the Program, including
                canceling your service plan or selling or transferring the phone
                number to another party, you agree that you will complete the
                User Opt Out process set forth above prior to ending your use of
                the mobile telephone number. You understand and agree that your
                agreement to do so is a material part of these terms and
                conditions. You further agree that, if you discontinue the use
                of your mobile telephone number without notifying Us of such
                change, you agree that you will be responsible for all costs
                (including attorneys’ fees) and liabilities incurred by Us,
                Recharge, or any party that assists in the delivery of the
                mobile messages, as a result of claims brought by individual(s)
                who are later assigned that mobile telephone number. This duty
                and agreement shall survive any cancellation or termination of
                your agreement to participate in any of our Programs.
              </p>
              <p>
                YOU AGREE THAT YOU SHALL INDEMNIFY, DEFEND, AND HOLD US AND
                RECHARGE HARMLESS FROM ANY CLAIM OR LIABILITY RESULTING FROM
                YOUR FAILURE TO COMPLY WITH YOUR DUTY TO NOTIFY US IN ACCORDANCE
                WITH THIS SECTION, INCLUDING ANY CLAIM OR LIABILITY UNDER THE
                TELEPHONE CONSUMER PROTECTION ACT, 47 U.S.C. § 227, et seq., OR
                SIMILAR STATE AND FEDERAL LAWS, AND ANY REGULATIONS PROMULGATED
                THEREUNDER RESULTING FROM US ATTEMPTING TO CONTACT YOU AT THE
                MOBILE TELEPHONE NUMBER YOU PROVIDED.
              </p>
              <h4>Program Description</h4>
              <p>
                Without limiting the scope of the Program, users can expect to
                receive messages concerning the management of the users digital
                subscription, events, available products and services, and
                special promotions.
              </p>
              <h4>Cost and Frequency</h4>
              <p>
                Message and data rates may apply. The Program involves recurring
                mobile messages, and additional mobile messages may be sent
                periodically based on your interaction with the Program.
              </p>
              <h4>Support Instructions</h4>
              <p>
                For support regarding the Program, text “HELP” to the number you
                received messages from our email at<span>&nbsp;</span>
                <Link onClick={toTop} to="mailto:find@sadiemall.site">
                  find@sadiemall.site
                </Link>
                . Please note that the use of this email address is not an
                acceptable method of opting out of the program. Opt outs must be
                submitted in accordance with the procedures set forth above.
              </p>
              <h4>Our Disclaimer of Warranty</h4>
              <p>
                The Program is offered on an “as-is” basis and may not be
                available in all areas at all times and may not continue to work
                in the event of product, software, coverage or other changes
                made by your wireless carrier. We and Recharge will not be
                liable for any delays or failures in the receipt of any mobile
                messages connected with this Program. Delivery of mobile
                messages is subject to effective transmission from your wireless
                service provider/network operator and is outside of Our and
                Recharge’s control.
              </p>
              <h4>Participant Requirements</h4>
              <p>
                You must have a wireless device of your own, capable of two-way
                messaging, be using a participating wireless carrier, and be a
                wireless service subscriber with text messaging service. Not all
                cellular phone providers carry the necessary service to
                participate. Check your phone capabilities for specific text
                messaging instructions.
              </p>
              <h4>Age Restriction</h4>
              <p>
                You may not use or engage with the Platform if you are under
                thirteen (13) years of age. If you use or engage with the
                Platform and are between the ages of thirteen (13) and eighteen
                (18) years of age, you must have your parent’s or legal
                guardian’s permission to do so. By using or engaging with the
                Platform, you acknowledge and agree that you are not under the
                age of thirteen (13) years, are between the ages of thirteen
                (13) and eighteen (18) and have your parent’s or legal
                guardian’s permission to use or engage with the Platform, or are
                of adult age in your jurisdiction. By using or engaging with the
                Platform, you also acknowledge and agree that you are permitted
                by your jurisdiction’s Applicable Law to use and/or engage with
                the Platform.
              </p>
              <h4>Prohibited Content</h4>
              <p>
                You acknowledge and agree to not send any prohibited content
                over the Platform. Prohibited content includes:
              </p>
              <ul>
                <li>
                  Any fraudulent, libelous, defamatory, scandalous, threatening,
                  harassing, or stalking activity;
                </li>
                <li>
                  Objectionable content, including profanity, obscenity,
                  lasciviousness, violence, bigotry, hatred, and discrimination
                  on the basis of race, sex, religion, nationality, disability,
                  sexual orientation, or age;
                </li>
                <li>
                  Pirated computer programs, viruses, worms, Trojan horses, or
                  other harmful code;
                </li>
                <li>
                  Any product, service, or promotion that is unlawful where such
                  product, service, or promotion thereof is received;
                </li>
                <li>
                  Any content that implicates and/or references personal health
                  information that is protected by the Health Insurance
                  Portability and Accountability Act (“HIPAA”) or the Health
                  Information Technology for Economic and Clinical Health Act
                  (“HITEC” Act); and
                </li>
                <li>
                  Any other content that is prohibited by Applicable Law in the
                  jurisdiction from which the message is sent.
                </li>
              </ul>
              <h4>Dispute Resolution</h4>
              <p>
                In the event that there is a dispute, claim, or controversy
                between you and Us, or between you and Recharge or any other
                third-party service provider acting on Our behalf to transmit
                the mobile messages within the scope of the Program, arising out
                of or relating to the Program, federal or state statutory
                claims, common law claims, this Agreement, or the breach,
                termination, enforcement, interpretation or validity thereof,
                including the determination of the scope or applicability of
                this agreement to arbitrate, such dispute, claim, or controversy
                will be, to the fullest extent permitted by law, determined
                through binding arbitration or, if applicable, in small claims
                court.
              </p>
              <p>
                Any arbitration shall be administered by the American
                Arbitration Association (“AAA”) in accordance with its
                Commercial Arbitration Rules or, if applicable, the Consumer
                Arbitration Rules, of then in effect. Except as otherwise
                provided herein, this arbitration agreement is governed by the
                Federal Arbitration Act (“FAA”) and the arbitrator shall apply
                the substantive laws of California, without regard to its
                conflict of laws rules. Within ten (10) calendar days after the
                arbitration demand is served upon a party, the parties must
                jointly select an arbitrator with at least five years’
                experience as an arbitrator and and have&nbsp; experience with
                the subject matter of the dispute. If the parties do not agree
                on an arbitrator within ten (10) calendar days, a party may
                petition the AAA to appoint an arbitrator, under the applicable
                rules, who must satisfy the same experience requirements. In the
                event of a dispute, the arbitrator shall decide the
                enforceability and interpretation of this arbitration agreement
                in accordance with the&nbsp; “FAA”. The parties also agree that
                the AAA’s rules governing Emergency Measures of Protection shall
                apply in lieu of seeking emergency injunctive relief from a
                court. The decision of the arbitrator shall be final and
                binding, and no party shall have rights of appeal except for
                those provided in section 10 of the FAA. If allowed for by the
                applicable rules, each party shall bear its share of the fees
                paid for the arbitrator and the administration of the
                arbitration; however, the arbitrator shall have the power to
                order one party to pay all or any portion of such fees as part
                of a well-reasoned decision. The parties agree that the
                arbitrator shall have the authority to award attorneys’ fees
                only to the extent expressly authorized by statute or contract.
                Unless expressly allowed for by applicable law, the arbitrator
                shall have no authority to award punitive damages and each party
                hereby waives any right to seek or recover punitive damages with
                respect to any dispute resolved by arbitration. The parties
                agree to arbitrate solely on an individual basis, and this
                agreement does not permit class arbitration or any claims
                brought as a plaintiff or class member in any class or
                representative arbitration proceeding. Except as may be required
                by law, neither a party nor the arbitrator may disclose the
                existence, content, or results of any arbitration without the
                prior written consent of both parties, unless to protect or
                pursue a legal right. If any term or provision of this Section
                is invalid, illegal, or unenforceable in any jurisdiction, such
                invalidity, illegality, or unenforceability shall not affect any
                other term or provision of this Section or invalidate or render
                unenforceable such term or provision in any other jurisdiction.
                If for any reason a dispute proceeds in court rather than in
                arbitration, the parties hereby waive any right to a jury trial.
                This arbitration provision shall survive any cancellation or
                termination of your agreement to participate in any of our
                Programs.
              </p>
              <p>
                Miscellaneous: You warrant and represent to Us that you have all
                necessary rights, power, and authority to agree to these Terms
                and perform your obligations hereunder, and nothing contained in
                this Agreement or in the performance of such obligations will
                place you in breach of any other contract or obligation. The
                failure of either party to exercise in any respect any right
                provided for herein will not be deemed a waiver of any further
                rights hereunder. If any provision of this Agreement is found to
                be unenforceable or invalid, that provision will be limited or
                eliminated to the minimum extent necessary so that this
                Agreement will otherwise remain in full force and effect and
                enforceable. Any new features, changes, updates or improvements
                of the Program shall be subject to this Agreement unless
                explicitly stated otherwise in writing. We reserve the right to
                change this Agreement from time to time. Any updates to this
                Agreement shall be communicated to you. You acknowledge your
                responsibility to review this Agreement from time to time and to
                be aware of any such changes. By continuing to participate in
                the Program after any such changes, you accept this Agreement,
                as modified.
              </p>
              <p>
                <strong>SECTION 10 - THIRD-PARTY LINKS</strong> <br /> Certain
                content, products and services available via our Service may
                include materials from third-parties. <br /> Third-party links
                on this site may direct you to third-party websites that are not
                affiliated with us. We are not responsible for examining or
                evaluating the content or accuracy and we do not warrant and
                will not have any liability or responsibility for any
                third-party materials or websites, or for any other materials,
                products, or services of third-parties. <br /> We are not liable
                for any harm or damages related to the purchase or use of goods,
                services, resources, content, or any other transactions made in
                connection with any third-party websites. Please review
                carefully the third-party's policies and practices and make sure
                you understand them before you engage in any transaction.
                Complaints, claims, concerns, or questions regarding third-party
                products should be directed to the third-party. <br /> <br />{" "}
                <strong>
                  SECTION 11 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS
                </strong>{" "}
                <br /> If, at our request, you send certain specific submissions
                (for example contest entries) or without a request from us you
                send creative ideas, suggestions, proposals, plans, or other
                materials, whether online, by email, by postal mail, or
                otherwise (collectively, 'comments'), you agree that we may, at
                any time, without restriction, edit, copy, publish, distribute,
                translate and otherwise use in any medium any comments that you
                forward to us. We are and shall be under no obligation (1) to
                maintain any comments in confidence; (2) to pay compensation for
                any comments; or (3) to respond to any comments. <br /> We may,
                but have no obligation to, monitor, edit or remove content that
                we determine in our sole discretion are unlawful, offensive,
                threatening, libelous, defamatory, pornographic, obscene or
                otherwise objectionable or violates any party’s intellectual
                property or these Terms of Service. <br /> You agree that your
                comments will not violate any right of any third-party,
                including copyright, trademark, privacy, personality or other
                personal or proprietary right. You further agree that your
                comments will not contain libelous or otherwise unlawful,
                abusive or obscene material, or contain any computer virus or
                other malware that could in any way affect the operation of the
                Service or any related website. You may not use a false e‑mail
                address, pretend to be someone other than yourself, or otherwise
                mislead us or third-parties as to the origin of any comments.
                You are solely responsible for any comments you make and their
                accuracy. We take no responsibility and assume no liability for
                any comments posted by you or any third-party. <br /> <br />{" "}
                <strong>SECTION 12 - PERSONAL INFORMATION</strong> <br /> Your
                submission of personal information through the store is governed
                by our Privacy Policy. To view our Privacy Policy. <br /> <br />{" "}
                <strong>SECTION 13 - ERRORS, INACCURACIES AND OMISSIONS</strong>{" "}
                <br /> Occasionally there may be information on our site or in
                the Service that contains typographical errors, inaccuracies or
                omissions that may relate to product descriptions, pricing,
                promotions, offers, product shipping charges, transit times and
                availability. We reserve the right to correct any errors,
                inaccuracies or omissions, and to change or update information
                or cancel orders if any information in the Service or on any
                related website is inaccurate at any time without prior notice
                (including after you have submitted your order). <br /> We
                undertake no obligation to update, amend or clarify information
                in the Service or on any related website, including without
                limitation, pricing information, except as required by law. No
                specified update or refresh date applied in the Service or on
                any related website, should be taken to indicate that all
                information in the Service or on any related website has been
                modified or updated. <br /> <br />{" "}
                <strong>SECTION 14 - PROHIBITED USES</strong> <br /> In addition
                to other prohibitions as set forth in the Terms of Service, you
                are prohibited from using the site or its content: (a) for any
                unlawful purpose; (b) to solicit others to perform or
                participate in any unlawful acts; (c) to violate any
                international, federal, provincial or state regulations, rules,
                laws, or local ordinances; (d) to infringe upon or violate our
                intellectual property rights or the intellectual property rights
                of others; (e) to harass, abuse, insult, harm, defame, slander,
                disparage, intimidate, or discriminate based on gender, sexual
                orientation, religion, ethnicity, race, age, national origin, or
                disability; (f) to submit false or misleading information; (g)
                to upload or transmit viruses or any other type of malicious
                code that will or may be used in any way that will affect the
                functionality or operation of the Service or of any related
                website, other websites, or the Internet; (h) to collect or
                track the personal information of others; (i) to spam, phish,
                pharm, pretext, spider, crawl, or scrape; (j) for any obscene or
                immoral purpose; or (k) to interfere with or circumvent the
                security features of the Service or any related website, other
                websites, or the Internet. We reserve the right to terminate
                your use of the Service or any related website for violating any
                of the prohibited uses. <br /> <br />{" "}
                <strong>
                  SECTION 15 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY
                </strong>{" "}
                <br /> We do not guarantee, represent or warrant that your use
                of our service will be uninterrupted, timely, secure or
                error-free. <br /> We do not warrant that the results that may
                be obtained from the use of the service will be accurate or
                reliable. <br /> You agree that from time to time we may remove
                the service for indefinite periods of time or cancel the service
                at any time, without notice to you. <br /> You expressly agree
                that your use of, or inability to use, the service is at your
                sole risk. The service and all products and services delivered
                to you through the service are (except as expressly stated by
                us) provided 'as is' and 'as available' for your use, without
                any representation, warranties or conditions of any kind, either
                express or implied, including all implied warranties or
                conditions of merchantability, merchantable quality, fitness for
                a particular purpose, durability, title, and non-infringement.{" "}
                <br /> In no case shall Sadiemall, our directors, officers,
                employees, affiliates, agents, contractors, interns, suppliers,
                service providers or licensors be liable for any injury, loss,
                claim, or any direct, indirect, incidental, punitive, special,
                or consequential damages of any kind, including, without
                limitation lost profits, lost revenue, lost savings, loss of
                data, replacement costs, or any similar damages, whether based
                in contract, tort (including negligence), strict liability or
                otherwise, arising from your use of any of the service or any
                products procured using the service, or for any other claim
                related in any way to your use of the service or any product,
                including, but not limited to, any errors or omissions in any
                content, or any loss or damage of any kind incurred as a result
                of the use of the service or any content (or product) posted,
                transmitted, or otherwise made available via the service, even
                if advised of their possibility. Because some states or
                jurisdictions do not allow the exclusion or the limitation of
                liability for consequential or incidental damages, in such
                states or jurisdictions, our liability shall be limited to the
                maximum extent permitted by law. <br /> <br />{" "}
                <strong>SECTION 16 - INDEMNIFICATION</strong> <br /> You agree
                to indemnify, defend and hold harmless Sadiemall and our parent,
                subsidiaries, affiliates, partners, officers, directors, agents,
                contractors, licensors, service providers, subcontractors,
                suppliers, interns and employees, harmless from any claim or
                demand, including reasonable attorneys’ fees, made by any
                third-party due to or arising out of your breach of these Terms
                of Service or the documents they incorporate by reference, or
                your violation of any law or the rights of a third-party. <br />{" "}
                <br /> <strong>SECTION 17 - SEVERABILITY</strong> <br /> In the
                event that any provision of these Terms of Service is determined
                to be unlawful, void or unenforceable, such provision shall
                nonetheless be enforceable to the fullest extent permitted by
                applicable law, and the unenforceable portion shall be deemed to
                be severed from these Terms of Service, such determination shall
                not affect the validity and enforceability of any other
                remaining provisions. <br /> <br />{" "}
                <strong>SECTION 18 - TERMINATION</strong> <br /> The obligations
                and liabilities of the parties incurred prior to the termination
                date shall survive the termination of this agreement for all
                purposes. <br /> These Terms of Service are effective unless and
                until terminated by either you or us. You may terminate these
                Terms of Service at any time by notifying us that you no longer
                wish to use our Services, or when you cease using our site.{" "}
                <br /> If in our sole judgment you fail, or we suspect that you
                have failed, to comply with any term or provision of these Terms
                of Service, we also may terminate this agreement at any time
                without notice and you will remain liable for all amounts due up
                to and including the date of termination; and/or accordingly may
                deny you access to our Services (or any part thereof). <br />{" "}
                <br /> <strong>SECTION 19 - ENTIRE AGREEMENT</strong> <br /> The
                failure of us to exercise or enforce any right or provision of
                these Terms of Service shall not constitute a waiver of such
                right or provision. <br /> These Terms of Service and any
                policies or operating rules posted by us on this site or in
                respect to The Service constitutes the entire agreement and
                understanding between you and us and govern your use of the
                Service, superseding any prior or contemporaneous agreements,
                communications and proposals, whether oral or written, between
                you and us (including, but not limited to, any prior versions of
                the Terms of Service). <br /> Any ambiguities in the
                interpretation of these Terms of Service shall not be construed
                against the drafting party. <br /> <br />{" "}
                <strong>SECTION 20 - GOVERNING LAW</strong> <br /> These Terms
                of Service and any separate agreements whereby we provide you
                Services shall be governed by and construed in accordance with
                the laws of United States. <br /> <br />{" "}
                <strong>SECTION 21 - CHANGES TO TERMS OF SERVICE</strong> <br />{" "}
                You can review the most current version of the Terms of Service
                at any time at this page. <br /> We reserve the right, at our
                sole discretion, to update, change or replace any part of these
                Terms of Service by posting updates and changes to our website.
                It is your responsibility to check our website periodically for
                changes. Your continued use of or access to our website or the
                Service following the posting of any changes to these Terms of
                Service constitutes acceptance of those changes. <br /> <br />{" "}
                <strong>SECTION 22 - CONTACT INFORMATION</strong> <br />{" "}
                Questions about the Terms of Service should be sent to us at
                find@sadiemall.site.
              </p>
              <p>
                <b>Text Marketing &amp; Notifications</b>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>By consenting to </span>
                <span style={{ fontWeight: 400 }}>Sadiemall’s </span>
                <span style={{ fontWeight: 400 }}>
                  SMS marketing in the checkout and initializing a purchase or
                  subscribing via our subscription tools, you agree to receive
                  recurring text notifications (for your order, including
                  abandoned checkout reminders), text marketing offers, and
                  transactional texts, including requests for reviews from us,
                  even if your mobile number is registered on any state or
                  federal do-not-call list. Message frequency varies. Consent is
                  not a condition of purchase.
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  If you wish to unsubscribe from receiving text marketing
                  messages and notifications, reply with STOP to any mobile
                  message sent from us or use the unsubscribe link we provided
                  you within any of our messages. You understand and agree that
                  alternative methods of opting out, such as using alternative
                  words or requests, will not be considered a reasonable means
                  of opting out. We do not charge for the service, but you are
                  responsible for all charges and fees associated with text
                  messaging imposed by your wireless provider. Message and data
                  rates may apply.
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  For any questions, please text HELP to the number you received
                  the messages from. You can also contact us{" "}
                </span>
                <Link onClick={toTop} to="/contact">
                  <span style={{ fontWeight: 400 }}>here</span>
                </Link>{" "}
                <span style={{ fontWeight: 400 }}>
                  for more information.&nbsp;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We have the right to modify any telephone number or short code
                  we use to operate the service at any time. You will be
                  notified on such occasions. You agree that any messages you
                  send to a telephone number or short code we have changed,
                  including any STOP or HELP requests, may not be received, and
                  we will not be liable for honoring requests made in such
                  messages.
                </span>
                <span style={{ fontWeight: 400 }}>&nbsp;</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  To the extent permitted by applicable law, you agree that we
                  will not be liable for failed, delayed, or misdirected
                  delivery of any information sent through the service, any
                  errors in such information, and/or any action you may or may
                  not take in reliance on the information or Service.
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Your right to privacy is important to us. You can see our
                  Privacy Policy{" "}
                </span>
                <Link onClick={toTop} to="/privacy">
                  <span style={{ fontWeight: 400 }}>here</span>
                </Link>{" "}
                <span style={{ fontWeight: 400 }}>
                  to determine how we collect and use your personal information.
                </span>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Terms;
